import React, { useState } from 'react';
import "../css/AboutUs.css"; // Assuming a combined CSS file named ContactUs.css

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    description: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here (e.g., send data to server)
    console.log('Form submitted:', formData);
    // You can add logic to reset the form or display a success message here
  };

  return (
    <div className="about-us">
      <h2>Contact Us</h2> {/* Assuming you want a heading */}
      <p>
        For Tech Support users can write to tech-support@advisormitra.com Mon-Fri 11 AM- 6 PM
      </p>
      <p>
        For Usage Support, users can write to support@advisormitra.com Mon-Fri 11 AM- 6 PM
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="mobile">Mobile:</label>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">Brief description of the Issue:</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default ContactUs;